module.exports = __webpack_public_path__ + "static/charleston_header-625a31eb8b21acae0e57ce445af48824.jpg";